import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import ArrowLeft from '../../Assets/Arrow left.svg';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCouponDetails } from '../../Features/couponsSlice';
import CouponInfo from './Components/CouponInfo';
import DotsVertical from '../../Assets/VerticalDot.svg';
import { useOutsideClickForTwoRef } from '../../Hooks/useOutsideClickForTwoRef';
import CouponDetailsKebab from './Components/CouponDetailsKebab';
import Loading from '../../Components/Loading/Loading';
import Error from '../../Components/Error/Error';
import { stripTimeFromDate } from '../../lib/utils/utils';

const getCouponStatus = (startDate, endDate, isVisible, isExpired) => {
    const today = stripTimeFromDate(new Date());
    const startDay = stripTimeFromDate(new Date(startDate));
    const endDay = stripTimeFromDate(new Date(endDate));

    const isInactive = !isVisible && !isExpired;
    const isTrulyExpired = (!isVisible && isExpired) || today > endDay || isExpired;

    if (isInactive) {
        return {
            name: 'Inactive',
            colors: 'text-[#666666] bg-[#EAEAEA]'
        };
    } else if (isTrulyExpired) {
        return {
            name: 'Expired',
            colors: 'text-[#991B1B] bg-[#FEE2E2]'
        };
    } else if (today < startDay) {
        return {
            name: 'Upcoming',
            colors: 'text-[#92400E] bg-[#FEF3C7]'
        };
    } else {
        return {
            name: 'Active',
            colors: 'text-[#065F46] bg-[#D1FAE5]'
        };
    }
};

function CouponDetails() {
    const dispatch = useDispatch();
    const params = useParams();

    const { coupon, loading } = useSelector((state) => state.coupons.coupon);

    const [couponStatus, setCouponStatus] = useState({});
    const [kebabVisible, setKebabVisible] = useState(false);

    const kebabRef = useRef(null);
    const kebabButtonRef = useRef(null);

    useOutsideClickForTwoRef(kebabRef, kebabButtonRef, () => {
        setKebabVisible(false);
    });

    const handleDotsClick = () => {
        setKebabVisible(!kebabVisible);
    }

    useEffect(() => {
        if(params.couponId) {
            params.couponId && dispatch(fetchCouponDetails(params.couponId));
        }
        // eslint-disable-next-line
    }, [params.couponId]);

    useEffect(() => {
        if(Object.keys(coupon).length > 0) {
            let obj = getCouponStatus(coupon.startDate, coupon.endDate, coupon.isVisible, coupon.isExpired);
            setCouponStatus(obj);
        }
    }, [coupon]);

    if(loading === 'loading') {
        return <Loading />
    }

    if(loading === 'failed') {
        return <Error />
    }

    return (
        <div className="size-full overflow-y-scroll pb-16 outline-none">
            <div className="select-none flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-fit flex items-center">
                    <Link to='..' className="p-[10px] flex items-center justify-center">
                        <img className='size-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>

                    <h1 className="p-[6px] text-[#121212] font-bold leading-8 text-[24px]">{coupon?.couponName}</h1>
                </div>

                <div className="flex items-center gap-3">
                    {
                        <div className={`rounded-xl ${couponStatus?.colors} px-3 py-[2px]`}>
                            <p className='text-sm'>{couponStatus?.name}</p>
                        </div>
                    }

                    <div onClick={handleDotsClick} ref={kebabButtonRef} className="relative size-11 outline-none flex items-center justify-center cursor-pointer">
                        <img src={DotsVertical} alt="" />

                        <CouponDetailsKebab 
                            kebabOpen={kebabVisible} 
                            boxRef={kebabRef} 
                        />
                    </div>
                </div>
            </div>

            <CouponInfo />
        </div>
    );
}

export default CouponDetails;
